import React, { useContext } from "react"
import * as styles from "./Styles/Container.module.scss"
import classNames from "classnames/bind"
import { PCViewContext } from "../Common/PCViewContext"
const cn = classNames.bind(styles)
import List from "./List"
import Pager from "../Common/Pager"

const Container = (props) => {
  const isPC = useContext(PCViewContext)

  return (
    <div className={cn("container", isPC ? "pc" : "sp")}>
      <h3 className={styles.header}>{props.place.name}の写真</h3>
      <div className={styles.annotations}>
        <span>{props.pagy.count}枚・</span>
        <a href={props.place.path}>この施設のページを見る</a>
      </div>
      <List {...props} />
      <Pager {...props} />
      <div className={styles.annotation}>
        ※写真は投稿された当時のもののため、最新の情報とは異なる場合があります。必ず事前にご確認のうえご利用ください。
      </div>
    </div>
  )
}

export default Container
